document.addEventListener('DOMContentLoaded', function() {
    // Select all elements with the class 'custom-hidden-price'
    var elements = document.querySelectorAll('.js-custom-hidden-price');

    // Add an event listener to each element
    elements.forEach(function(element) {
        element.addEventListener('click', function(event) {
            // Check if the clicked target is an 'a' element or an 'a' element descendant
            var link = event.target.closest('a');
            if (link) {
                // Prevent the default link behavior
                event.preventDefault();
                // Change the current page location to the href of the link
                window.location.href = link.href;
            }
        });
    });
});